import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "solojack",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...userVuex.mapState(["userData", "solojackPage"])
  },
  data() {
    return {
      selectTab: 0,
      popGetLuckyNumberShow: false,
      isDrawHistoryTabSelect: false,
      popDrawHistoryShow: false,
      luckyBase: null,
      luckyInfo: {
        prize: {
          value: null,
          total: null
        },
        round: {
          round_no: null
        },
        user: {
          info: {
            diamond: 0
          }
        }
      },
      buyLuckyNumberList: null,
      myNumberList: null,
      myNumberListPage: {
        total: 10,
        page: 1,
        limit: 50,
        loading: false
      },
      selectCount: null,
      isBtnBuyLoading: false,
      popLuckyResultShow: false,
      winnerInfo: null,
      leftLuckyNumberNum: null,
      isRefreshLoading: false,
      activityFeedsList: null,
      activityFeedsListPage: {
        total: 0,
        page: 1,
        limit: 100,
        finished: false,
        loading: false
      },
      drawHistoriesList: null,
      drawHistoriesListPage: {
        total: 10,
        page: 1,
        limit: 50,
        loading: false
      },
      popGetLuckyNumberInfoShow: false,
      popNewRoundLiveShow: false,
      isDiamondInsufficient: false,
      luckyNumberError: null,
      roundStatus: 0,
      popHangUpPromptShow: false
    };
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.solojackPage.solojackStatusTimer);
      clearTimeout(this.solojackPage.hangUpPromptTimer);
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  watch: {
    popGetLuckyNumberShow(bool) {
      if (!bool) {
        this.buyLuckyNumberList = null;
        this.luckyNumberError = null;
      }
    },
    isDrawHistoryTabSelect: {
      async handler(newBool, oldBool) {
        if (newBool != oldBool) {
          await this.getLuckyBoxDrawHistories(newBool);
        }
      }
    },
    "luckyInfo.prize.value": {
      async handler(newVal, oldVal) {
        console.log("newValnewVal", newVal, oldVal);
        if (newVal != oldVal && newVal > 0) {
          await this.getActivityFeedsListFunc();
          await this.getLuckyBoxMyNumbers();
        }
      }
    },
    popLuckyResultShow: {
      async handler(bool) {
        if (!bool) {
          this.popGetLuckyNumberShow = false;
          await this.getLuckyBoxInfo();
          await this.getActivityFeedsListFunc();
          await this.getLuckyBoxMyNumbers();
          await this.getLuckyBoxAvailableNumbers();
          this.getLuckyBoxStatus();
          clearTimeout(this.solojackPage.solojackStatusTimer);
          this.poolLuckyBoxStatus();
        }
      }
    },
    popNewRoundLiveShow: {
      async handler(bool) {
        if (!bool) {
          this.popGetLuckyNumberShow = false;
          await this.getLuckyBoxInfo();
          await this.getActivityFeedsListFunc();
          await this.getLuckyBoxMyNumbers();
          await this.getLuckyBoxAvailableNumbers();
          this.getLuckyBoxStatus();
          clearTimeout(this.solojackPage.solojackStatusTimer);
          this.poolLuckyBoxStatus();
        }
      }
    },
    popHangUpPromptShow: {
      async handler(bool) {
        if (!bool) {
          this.getLuckyBoxStatus();
          clearTimeout(this.solojackPage.hangUpPromptTimer);
          clearTimeout(this.solojackPage.solojackStatusTimer);
          await this.poolLuckyBoxStatus();
          this.setHangUpPromptFnc();
        }
      }
    }
  },
  methods: {
    onTab(bool) {
      this.selectTab = bool;
    },
    padStartFn(num) {
      return String(num).padStart(4, "0");
    },
    async onSelectCount(item) {
      this.selectCount = item;
      this.buyLuckyNumberList = null;
      await this.getLuckyBoxAvailableNumbers();
    },
    setSelectCount() {
      const luckyInfo = this.luckyInfo;
      const leftNumber = (luckyInfo.round_duration - luckyInfo.round.buy_count) * this.luckyInfo.price;
      if (leftNumber >= this.luckyInfo.user.info.diamond) {
        this.leftLuckyNumberNum = parseInt(this.luckyInfo.user.info.diamond / this.luckyInfo.price);
      } else {
        this.leftLuckyNumberNum = leftNumber;
      }
      console.log("xxxxxxxxxx", leftNumber, this.leftLuckyNumberNum);
      // this.leftLuckyNumberNum = parseInt((prize.total - prize.value) * 100);
      const leftNum = this.leftLuckyNumberNum;
      if (leftNum >= 10) {
        this.selectCount = 10;
      } else if (leftNum >= 5) {
        this.selectCount = 5;
      } else {
        this.selectCount = 1;
      }
    },
    async onShowGetLucky(isSet = true) {
      if (isSet) {
        this.setSelectCount();
      }
      if (this.luckyInfo.user.info.diamond < this.luckyInfo.price * this.selectCount) {
        this.luckyNumberError = "Not enough diamonds";
        this.isDiamondInsufficient = true;
      } else {
        this.luckyNumberError = null;
        this.isDiamondInsufficient = false;
      }
      this.popGetLuckyNumberShow = true;
      await this.getLuckyBoxAvailableNumbers();
    },
    async setPopDrawHistoryShow(selfOnly) {
      this.popDrawHistoryShow = true;
      await this.getLuckyBoxDrawHistories(this.isDrawHistoryTabSelect);
    },
    async getDrawHistorySelect(bool) {
      this.isDrawHistoryTabSelect = bool;
    },
    async initFn() {
      let luckyBase = await this.getLuckyBoxList();
      if (!luckyBase || luckyBase && luckyBase.length <= 0) {
        return;
      }
      this.luckyBase = luckyBase[0];
      if (!this.luckyBase) {
        return;
      }
      await this.getLuckyBoxInfo();
      await this.getLuckyBoxMyNumbers();
      this.getLuckyBoxStatus();
      clearTimeout(this.solojackPage.solojackStatusTimer);
      this.poolLuckyBoxStatus();
      await this.getActivityFeedsListFunc();
      window.addEventListener("scroll", this.handleScroll.bind(this));
      this.setHangUpPromptFnc();
    },
    async getLuckyBoxList() {
      const params = {
        playType: 1,
        roundType: 1
      };
      const res = await this.$http.post("/lucky/box/list", params);
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getLuckyBoxInfo() {
      const params = {
        boxId: this.luckyBase.id
      };
      const res = await this.$http.post("/lucky/box/info", params);
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.luckyInfo = data;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getLuckyBoxAvailableNumbers() {
      const params = {
        boxId: this.luckyBase.id,
        count: this.selectCount
      };
      const res = await this.$http.post("/lucky/box/available/numbers", params);
      return new Promise(resolve => {
        vailcode(res, async () => {
          let data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.buyLuckyNumberList = data;
          if (this.buyLuckyNumberList.length < this.selectCount) {
            this.buyLuckyNumberList = [];
            await this.getLuckyBoxInfo();
            this.setSelectCount();
            await this.getLuckyBoxAvailableNumbers();
          }
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async buyLuckyBoxNumber() {
      if (this.luckyInfo.user.info.diamond < this.luckyInfo.price) {
        this.popGetLuckyNumberInfoShow = true;
        return;
      }
      console.log(this.isBtnBuyLoading);
      if (this.isBtnBuyLoading) return;
      this.isBtnBuyLoading = true;
      this.luckyNumberError = null;
      const itemRow = this.buyLuckyNumberList.join(",");
      const params = {
        boxId: this.luckyBase.id,
        itemId: itemRow
      };
      const res = await this.$http.post("/lucky/box/buy", params);
      if (res.code == 0) {
        await this.getLuckyBoxInfo();
        try {
          this.popGetLuckyNumberShow = false;
          await this.getActivityFeedsListFunc();
          await this.getLuckyBoxMyNumbers();
          await this.getLuckyBoxAvailableNumbers();
          this.isBtnBuyLoading = false;
          this.$toasted.clear();
          this.$toasted.success("Get Successful!");
          this.getLuckyBoxStatus();
          clearTimeout(this.solojackPage.solojackStatusTimer);
        } catch (err) {
          this.isBtnBuyLoading = false;
        }
      } else {
        if (res.code === 409) {
          this.luckyNumberError = `${res.message},Re-changing number...`;
          this.isBtnBuyLoading = false;
          setTimeout(() => {
            this.onRefresh(true);
          }, 2000);
        } else {
          this.luckyNumberError = res.message;
          setTimeout(async () => {
            await this.getLuckyBoxStatus();
          }, 2000);
        }
      }
    },
    async getLuckyBoxActivityFeeds(params) {
      const _params = {
        roundId: this.luckyInfo.round.id,
        ...params
      };
      const res = await this.$http.post("/lucky/box/activity/feeds", _params);
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getLuckyBoxMyNumbers(page) {
      this.myNumberListPage.page = page || 1;
      const params = {
        roundId: this.luckyInfo.round.id,
        page: this.myNumberListPage.page,
        limit: this.myNumberListPage.limit
      };
      const res = await this.$http.post("/lucky/box/my/numbers", params);
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data.items;
          if (!data) {
            resolve();
            return;
          }
          this.myNumberList = data;
          this.myNumberListPage.total = res.data.total;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getLuckyBoxDrawHistories(selfOnly, page) {
      console.log("selfOnly", selfOnly);
      this.drawHistoriesListPage.page = page || 1;
      const params = {
        boxId: this.luckyBase.id,
        page: this.drawHistoriesListPage.page,
        limit: this.drawHistoriesListPage.limit
      };
      if (selfOnly) {
        params["selfOnly"] = 1;
      }
      if (this.drawHistoriesListPage.loading) return;
      this.drawHistoriesListPage.loading = true;
      this.drawHistoriesList = null;
      const res = await this.$http.post("/lucky/box/draw/histories", params);
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data.items;
          if (!data) {
            this.drawHistoriesListPage.loading = false;
            resolve();
            return;
          }
          this.drawHistoriesListPage.loading = false;
          this.drawHistoriesList = data;
          this.drawHistoriesListPage.total = res.data.total;
          resolve(data);
        }, () => {
          this.drawHistoriesListPage.loading = false;
          resolve();
        });
      });
    },
    async getLuckyBoxStatus() {
      const data = await this.getLuckyBoxRoundStatus();
      if (!data) {
        clearTimeout(this.solojackPage.solojackStatusTimer);
        return;
      }
      this.roundStatus = data.status;
      if (data.status >= 3) {
        await this.getLuckyBoxWinningStatus(data.id);
        if (this.myNumberList.length <= 0) {
          this.popNewRoundLiveShow = true;
          await this.getLuckyBoxInfo();
          await this.getActivityFeedsListFunc();
          await this.getLuckyBoxMyNumbers();
          await this.getLuckyBoxAvailableNumbers();
          clearTimeout(this.solojackPage.solojackStatusTimer);
          // this.poolLuckyBoxStatus();
          // this.getLuckyBoxStatus();
        } else {
          this.popLuckyResultShow = true;
        }
      } else {
        clearTimeout(this.solojackPage.solojackStatusTimer);
        await this.poolLuckyBoxStatus();
      }
    },
    async poolLuckyBoxStatus() {
      this.solojackPage.solojackStatusTimer = setTimeout(async () => {
        this.getLuckyBoxStatus();
      }, 12000);
    },
    async getLuckyBoxRoundStatus() {
      const params = {
        id: this.luckyInfo.round.id
      };
      const res = await this.$http.post("/lucky/box/round/status", params);
      // const res = {
      //     code: 0,
      //     message: "",
      //     data: {
      //       id: 204,
      //       status: 4,
      //       prize: {
      //         value: 0.1,
      //         total: 0.1,
      //         currency: "TON",
      //       },
      //     },
      //   };
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.luckyInfo.prize = data.prize;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getLuckyBoxWinningStatus(roundId) {
      const params = {
        roundId,
        withWinner: 1
      };
      const res = await this.$http.post("/lucky/box/winning/status", params);
      // const res = {
      //   code: 0,
      //   message: "",
      //   data: {
      //     id: 213,
      //     round_no: 17,
      //     winning_item_id: 1008,
      //     winning_item_name: null,
      //     winning_count: 1,
      //     winning_amount: 0.1,
      //     draw_countdown: 0,
      //     status: 1,
      //     winners: [
      //       {
      //         id: 6,
      //         firstname: "wjm123",
      //         lastname: "",
      //         head_color: "#cf5fa7",
      //         avatar_url: "2",
      //       },
      //     ],
      //   },
      // };
      return new Promise(resolve => {
        vailcode(res, () => {
          let data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.winnerInfo = data;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async onRefresh(bool) {
      if (this.isRefreshLoading) return;
      this.isRefreshLoading = true;
      this.buyLuckyNumberList = null;
      setTimeout(async () => {
        await this.onShowGetLucky(bool);
        this.isRefreshLoading = false;
      }, 500);
    },
    async onLuckyResultDetail() {
      this.popLuckyResultShow = false;
      await this.getLuckyBoxInfo();
      await this.setPopDrawHistoryShow();
      await this.getActivityFeedsListFunc();
      await this.getLuckyBoxMyNumbers();
      await this.getLuckyBoxAvailableNumbers();
      this.getLuckyBoxStatus();
      clearTimeout(this.solojackPage.solojackStatusTimer);
      this.poolLuckyBoxStatus();
    },
    async getActivityFeedsListFunc(isPage) {
      if (this.selectTab == 1) {
        window.removeEventListener("scroll", this.handleScroll);
        return;
      }
      this.activityFeedsListPage.page++;
      if (!isPage) {
        this.activityFeedsListPage.page = 1;
      }
      const params = {
        page: this.activityFeedsListPage.page,
        limit: this.activityFeedsListPage.limit
      };
      if (this.activityFeedsListPage.loading) return;
      this.activityFeedsListPage.loading = true;
      const res = await this.getLuckyBoxActivityFeeds(params);
      if (!isPage) {
        this.activityFeedsList = [];
      }
      if (!res) {
        this.activityFeedsListPage.loading = false;
        return;
      }
      this.activityFeedsListPage.total = res.total;
      this.activityFeedsList.push(...res.items);
      this.activityFeedsListPage.finished = this.activityFeedsList.length >= this.activityFeedsListPage.total; // 没有更多数据
      this.activityFeedsListPage.loading = false;
    },
    async handleScroll() {
      if (this.activityFeedsListPage.loading || this.activityFeedsListPage.finished) return;
      // 获取页面滚动的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 判断是否接近页面底部（距离底部100px以内时触发加载更多）
      if (scrollTop + windowHeight + 1 >= documentHeight) {
        await this.getActivityFeedsListFunc(true);
      }
    },
    async onPopDrawPageChange(page) {
      this.drawHistoriesListPage.page = page;
      await this.getLuckyBoxDrawHistories(this.isDrawHistoryTabSelect, page);
    },
    onJoinRound() {
      this.popNewRoundLiveShow = false;
    },
    async onMyNumberChange(page) {
      this.myNumberListPage.page = page;
      await this.getLuckyBoxMyNumbers(page);
    },
    setHangUpPromptFnc() {
      this.solojackPage.hangUpPromptTimer = setTimeout(() => {
        if (this.myNumberList.length <= 0) {
          clearTimeout(this.solojackPage.hangUpPromptTimer);
          clearTimeout(this.solojackPage.solojackStatusTimer);
          this.popHangUpPromptShow = true;
        } else {
          this.popHangUpPromptShow = false;
          this.setHangUpPromptFnc();
        }
      }, 3 * 60 * 1000);
    },
    async onHangUpPromptGetLuckyNumber() {
      this.popHangUpPromptShow = false;
      await this.onShowGetLucky();
    }
  },
  mounted() {
    this.$nextTick(this.initFn);
  }
};